import { useTranslation } from 'react-i18next';

export default function HomeFAQ() {
  const { t } = useTranslation();
  const faqCount = 6;
  const faqs = Array.from({ length: faqCount }, (_, i) => ({
    question: t(`home.faq.items.${i}.question`),
    answer: t(`home.faq.items.${i}.answer`),
  }));

  return (
    <section className="py-16 lg:py-24 bg-gray-50/80 border-t border-gray-100">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="inline-block text-[11px] font-bold text-blue-600 uppercase tracking-wider mb-2">
            {t('home.faq.supportLabel')}
          </span>
          <h2 className="text-2xl lg:text-3xl font-bold text-gray-900 mb-3">
            {t('home.faq.title')}
          </h2>
          <p className="text-base text-gray-600">
            {t('home.faq.subtitle')}
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((item, i) => (
            <details key={i} className="bg-white rounded-xl border border-gray-100 group">
              <summary className="flex items-center justify-between p-5 cursor-pointer text-sm font-semibold text-gray-900 list-none">
                <span className="pr-4">{item.question}</span>
                <i className="ri-add-line text-gray-400 group-open:hidden flex-shrink-0"></i>
                <i className="ri-subtract-line text-blue-600 hidden group-open:block flex-shrink-0" />
              </summary>
              <div className="px-5 pb-5 -mt-1">
                <p className="text-sm text-gray-600 leading-relaxed">{item.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
